

































import mixins from 'vue-typed-mixins'
import Spinner from '@/components/Spinner.vue'
import VirtualScrollMixin from '@/mixins/VirtualScrollMixin'

export default mixins(VirtualScrollMixin).extend({
  name: 'BlockList',
  components: {
    Spinner
  },
  data() {
    return {
      fetchPayload: {
        url: '/blocklist/',
        params: {
          page: 'get_init'
        }
      },
      isLoading: false
    }
  },
  computed: {
    entries(): any {
      return this.$store.getters['Block/entries']
    },

    enabledInfinite(): boolean {
      return this.$store.getters['Block/enabledInfinite']
    },

    itemHeight(): number {
      return 96
    }
  },
  async created() {
    this.fetchPayload.params['p'] = 0
    await this.fetchData()
  },
  async mounted() {
    await this.$nextTick()
    this.$_setHandleScroll(1000, this.handleInfinite)
  },
  methods: {
    fetchData(): Promise<any> {
      return this.$store.dispatch('Block/getEntries', this.fetchPayload)
    },

    /**
     * ブロック解除
     */
    async unblock(id: string, targetIndex: number) {
      try {
        const buttonIndex = await this.$_confirm('ブロックを解除しますか？', '', [
          'キャンセル',
          '解除する'
        ])
        if (!this.$_clickedConfirmOK(buttonIndex)) {
          return
        }
        await this.$http.post('/blocklist/', {
          page: 'unblock',
          id: id
        })
        this.$store.commit('Block/removeEntry', targetIndex)
      } catch (err) {
        this.$_alert(err)
      }
    },

    /**
     * 無限スクロール
     */
    async handleInfinite() {
      if (this.isLoading || !this.enabledInfinite) {
        return
      }
      this.isLoading = true
      await this.$store.dispatch('Block/infinite', {
        fetchPayload: this.fetchPayload
      })
      this.isLoading = false
    }
  }
})
